import Tile from "./Tile";

export default function TechAreaForm({
  techAreas,
  jobRoleDetails,
  onSelectTechArea
}) {
  return (
    <>
      {techAreas.map((techArea) => (
        <Tile
          item={techArea}
          onSelect={onSelectTechArea}
          jobRoleDetails={jobRoleDetails}
          field="techAreaId"
        />
      ))}
    </>
  );
}
